import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { CompanyProvider } from '../contexts/CompanyContext';

/**
 * Wraps children in a single CompanyProvider that reactively reads the
 * company ID from the URL. Persists across all navigations within the
 * protected route tree — no unmount/remount on route changes.
 */
export const CompanyProviderFromUrl: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  const companyId = useMemo(() => {
    const match = location.pathname.match(
      /\/(dealers|loans|floorplans|borrowing-base|imports)\/(\d+)/
    );
    return match ? match[2] : null;
  }, [location.pathname]);

  return <CompanyProvider selectedCompanyId={companyId}>{children}</CompanyProvider>;
};
